import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
export const Range = ({ value, onChange, min, max, step }) => {
    return (_jsx(_Fragment, { children: _jsx("input", { type: "range", className: "w-full h-2 bg-gray-300 rounded-lg appearance-none cursor-pointer focus:outline-none focus:ring-2 focus:ring-blue-500", value: value, onChange: (event) => (onChange) ? onChange(event) : null, min: min, max: max, step: step }) }));
};
